module.exports = __webpack_public_path__ + "img/96.a568914d.jpg";